import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Chip, Input, Modal } from "../../components/ui";
import { DataTable, when } from "../../components/admin/fields";
import useCursorList from "../../components/admin/useCursorList";
import { useToast } from "../../context/ToastContext";
import content from "../../services/api-content";
import "../../styles/content.css";

const TARGET_LINK = { character: (id) => `/c/${id}`, universe: (id) => `/universe/${id}`, user: (id) => `/creator/${id}` };

export function AdminReports() {
  const toast = useToast();
  const [status, setStatus] = useState("open");
  const [sel, setSel] = useState(null);
  const [text, setText] = useState("");
  const list = useCursorList((cursor) => content.admin.reports.list({ ...(status ? { status } : {}), cursor }), [status]);
  const resolve = async () => {
    try { await content.admin.reports.resolve(sel.id, text.trim()); toast("ปิดรายงานแล้ว", "success"); setSel(null); setText(""); list.reload(); } catch (e) { toast(e.message, "error"); }
  };
  const cols = [
    { key: "createdAt", label: "เมื่อ", render: (r) => when(r.createdAt) },
    { key: "targetType", label: "ประเภท" },
    { key: "target", label: "เป้าหมาย", render: (r) => (TARGET_LINK[r.targetType] ? <Link to={TARGET_LINK[r.targetType](r.targetId)}>เปิดดู</Link> : <span className="faint" title={r.targetId}>{String(r.targetId).slice(0, 12)}</span>) },
    { key: "category", label: "หมวด" },
    { key: "details", label: "รายละเอียด", render: (r) => <span className="clamp-2" style={{ maxWidth: 260, display: "inline-block" }}>{r.details || "-"}</span> },
    { key: "status", label: "สถานะ", render: (r) => <span className={`pill ${r.status === "open" ? "pill--warn" : "pill--ok"}`}>{r.status === "open" ? "รอตรวจ" : "ปิดแล้ว"}</span> },
    { key: "act", label: "", render: (r) => (r.status === "open" ? <Button size="sm" variant="primary" onClick={() => { setSel(r); setText(""); }}>ปิดเรื่อง</Button> : <span className="faint clamp-1">{r.resolution}</span>) },
  ];
  return (
    <div>
      <div className="chip-row mb-16">{[["open", "รอตรวจ"], ["resolved", "ปิดแล้ว"], ["", "ทั้งหมด"]].map(([v, l]) => <Chip key={l} active={status === v} onClick={() => setStatus(v)}>{l}</Chip>)}</div>
      <DataTable columns={cols} rows={list.items} loading={list.loading} error={list.error} onRetry={list.reload} hasMore={!!list.next} onMore={list.loadMore} moreLoading={list.more} empty="ไม่มีรายงาน" />
      <Modal open={!!sel} onClose={() => setSel(null)} title="ปิดรายงาน" footer={<><Button variant="ghost" onClick={() => setSel(null)}>ยกเลิก</Button><Button variant="primary" onClick={resolve}>ยืนยัน</Button></>}>
        <p className="muted mb-8">{sel?.category}: {sel?.details || "-"}</p>
        <Input multiline label="ผลการดำเนินการ" value={text} onChange={(e) => setText(e.target.value)} />
      </Modal>
    </div>
  );
}

export function AdminTopups() {
  const [status, setStatus] = useState("");
  const list = useCursorList((cursor) => content.admin.topups.list({ ...(status ? { status } : {}), cursor }), [status]);
  const cols = [
    { key: "createdAt", label: "เมื่อ", render: (r) => when(r.createdAt) },
    { key: "id", label: "Transaction", render: (r) => <span className="faint" title={r.id}>{String(r.id).slice(0, 14)}</span> },
    { key: "userId", label: "ผู้ใช้", render: (r) => <span className="faint">{String(r.userId).slice(0, 12)}</span> },
    { key: "amount", label: "ยอด (฿)" },
    { key: "coins", label: "คอยน์" },
    { key: "status", label: "สถานะ", render: (r) => <span className={`pill ${r.status === "credited" ? "pill--ok" : "pill--warn"}`}>{r.status === "credited" ? "เติมแล้ว" : "รอยืนยัน"}</span> },
    { key: "creditedAt", label: "เติมเมื่อ", render: (r) => when(r.creditedAt) },
  ];
  return (
    <div>
      <div className="chip-row mb-16">{[["", "ทั้งหมด"], ["credited", "เติมแล้ว"], ["pending", "รอยืนยัน"]].map(([v, l]) => <Chip key={l} active={status === v} onClick={() => setStatus(v)}>{l}</Chip>)}</div>
      <DataTable columns={cols} rows={list.items} loading={list.loading} error={list.error} onRetry={list.reload} hasMore={!!list.next} onMore={list.loadMore} moreLoading={list.more} empty="ยังไม่มีรายการเติมเงิน" />
    </div>
  );
}
